import { API } from '@app/constants/api';
import { IReportUploadingResponse } from '@typings/report';
import axios from 'axios';

export const getReport = async ({
  companyId,
  reportId,
}: {
  companyId: string;
  reportId: string;
}): Promise<IReportUploadingResponse['report']> => {
  return (
    await axios.get<IReportUploadingResponse>(
      `${API.endpoint}/companies/${companyId}/reports/${reportId}`,
      {
        params: {
          job_type: 'api_upload',
        },
      }
    )
  )?.data?.report;
};
